/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
    customizeProductItem: (componentRegistry) => {
        function updateTitleAndAddBadges(element) {
            let product_id = element.getParams().props.product.id;
            let productData = element.getParams().props.product;
            let productItem = document.querySelector('[data-product-id="' + product_id + '"]');
            // Start customizing product title
            if (productData.hasOwnProperty('skus') && productData.skus[0]) {
                const productTitle = element.getParams().props.product.title;
                productItem.querySelector('.boost-sd__product-title').innerHTML = addSkuInfo(productTitle, productData.skus[0]);
            }
            // End customizing product title
            // Start customizing inventory badge
            let inventoryCount = 0;
            if (productData.variants && productData.variants.length) {
                productData.variants.forEach(function(variant) {
                    if (variant.hasOwnProperty('inventory_quantity') && variant.inventory_quantity > 0) {
                        inventoryCount += variant.inventory_quantity;
                    }
                });
            }
            if (inventoryCount < 5 && inventoryCount > 0) {
                let inventoryBadge = `<div class="boost-sd-inventory-badge"><span>${inventoryCount} in stock</span></div>`;
                let productImageWrapper = productItem.querySelector('.boost-sd__product-image-column--right');
                if (productImageWrapper) {
                    productImageWrapper.insertAdjacentHTML('afterbegin', inventoryBadge);
                }
            }
            // End customizing inventory badge
        }

        function addSkuInfo(productTitle, sku) {
            let newTitle = productTitle;
            if (productTitle.indexOf(sku) !== -1) {
              newTitle = productTitle.replace(sku, sku + '</br>').replace('|','');
            }
            // let splittedTitle = productTitle.split('<br/> ');
            // if (splittedTitle.length > 1) {
            //     newTitle = '<span>' + sku + '<br/>' + splittedTitle[1] + '</span>';
            // } else {
            //     if (splittedTitle[0].split('<br/>').length > 1) { //Fix for case where a space is not added after <br/>
            //         newTitle = '<span>' + sku + '<br/>' + splittedTitle[0].split('<br/>')[1] + '</span>';
            //     } else {
            //         newTitle = '<span>' + sku + '<br/>' + splittedTitle[0] + '</span>';
            //     }
            // }
            return newTitle;
        }

        const updateProductItemGridView = {
            name: 'Modify Product Title and add in stock badge grid view #181449',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateTitleAndAddBadges(element);
                }
            })
        };
        const updateProductItemListView = {
            name: 'Modify Product Title and add in stock badge list view #181449',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    updateTitleAndAddBadges(element);
                }
            }),
        };

        // Register updateProductList When ProductList rendered
        componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
        componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
    },
  	setWidthParamSearchProductItem: (componentRegistry) => {
    	 const setWidth = {
            name: 'Modify Product Title and add in stock badge list view #181449',
            enabled: true,
            apply: () => ({
                props(props) {
                    console.log(props.product.images);

                    let newImages = [];

                    
                  
                    // props.product = {...props.product, images_info: newImages};
                  
                  	props.product.images_info.map(image=> {
                    	image.src = `${image.src}&width=200`;
                      return image;
                    });
                  
                  	console.log('after', props);
                  	return props;
                }
            }),
        };

      
        componentRegistry.useComponentPlugin('SearchProductItem', setWidth);
    }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.customizeProductItem, customize.setWidthParamSearchProductItem]);